const BADGES = {
    ADMIN : 'ADMIN',
    MODO : 'MODO',
    CERTIFIED : 'CERTIFIED',
    GOLD : 'GOLD',
    NEW_USER : 'NEW_USER'
}

export {
    BADGES
};